import { useEffect, useRef, useState } from "react";
import { Music } from "lucide-react";

export default function MusicToggle() {
  const audioRef = useRef(null);
  const armedRef = useRef(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = new Audio("/music/love-is-in-the-air.mp3");
    audio.loop = true;
    audio.volume = 0.35;
    audio.preload = "auto";
    audioRef.current = audio;
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  const start = () => {
    if (!audioRef.current || armedRef.current) return;
    audioRef.current
      .play()
      .then(() => {
        armedRef.current = true;
        setPlaying(true);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const onStart = (e) => {
      if (armedRef.current) return;
      if (e.target?.closest?.('[data-testid="music-toggle"]')) return;
      start();
    };
    window.addEventListener("pointerdown", onStart);
    window.addEventListener("scroll", onStart, { passive: true });
    window.addEventListener("keydown", onStart);
    return () => {
      window.removeEventListener("pointerdown", onStart);
      window.removeEventListener("scroll", onStart);
      window.removeEventListener("keydown", onStart);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      armedRef.current = true;
      audioRef.current
        .play()
        .then(() => setPlaying(true))
        .catch(() => {});
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="music-toggle"
      aria-label={playing ? "Couper la musique" : "Jouer la musique"}
      title={playing ? "Love Is in the Air — couper" : "Love Is in the Air — jouer"}
      className="fixed bottom-5 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-gold/60 bg-ink/85 text-gold shadow-[0_0_25px_rgba(212,175,55,0.35)] backdrop-blur-sm transition-colors hover:bg-gold hover:text-ink"
    >
      {playing ? (
        <span className="flex items-end gap-[3px]" data-testid="music-equalizer">
          <span
            className="w-[3px] animate-pulse rounded-full bg-current"
            style={{ height: 9, animationDelay: "0ms" }}
          />
          <span
            className="w-[3px] animate-pulse rounded-full bg-current"
            style={{ height: 16, animationDelay: "150ms" }}
          />
          <span
            className="w-[3px] animate-pulse rounded-full bg-current"
            style={{ height: 11, animationDelay: "300ms" }}
          />
        </span>
      ) : (
        <Music size={17} />
      )}
    </button>
  );
}
